var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_2513)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76024 10.3875C4.81962 10.4586 4.90712 10.5 5.00008 10.5C5.09304 10.5 5.18055 10.4586 5.23992 10.3875C5.23992 10.3875 6.38372 9.0156 7.29812 7.3695C7.92546 6.2402 8.43762 4.9828 8.43762 3.9375C8.43762 2.0402 6.89742 0.5 5.00012 0.5C3.10282 0.5 1.56262 2.0402 1.56262 3.9375C1.56262 4.9828 2.07473 6.2402 2.70212 7.3695C3.61657 9.0156 4.76032 10.3875 4.76032 10.3875H4.76024ZM5.00008 9.68672C4.62586 9.20703 3.88058 8.20392 3.24808 7.06562C2.67542 6.03472 2.18758 4.89222 2.18758 3.93752C2.18758 2.38522 3.44778 1.12502 5.00008 1.12502C6.55238 1.12502 7.81258 2.38522 7.81258 3.93752C7.81258 4.89221 7.32469 6.03482 6.75208 7.06562C6.11966 8.20392 5.37438 9.20702 5.00008 9.68672ZM5.00008 2.06252C3.96528 2.06252 3.12508 2.90275 3.12508 3.93752C3.12508 4.97229 3.96531 5.81252 5.00008 5.81252C6.03485 5.81252 6.87508 4.97229 6.87508 3.93752C6.87508 2.90275 6.03485 2.06252 5.00008 2.06252ZM5.00008 2.68752C5.68992 2.68752 6.25008 3.24768 6.25008 3.93752C6.25008 4.62736 5.68992 5.18752 5.00008 5.18752C4.31024 5.18752 3.75008 4.62736 3.75008 3.93752C3.75008 3.24768 4.31024 2.68752 5.00008 2.68752Z",
    fill: "#6B6B6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_2513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.01ac3ac2344c184b79871a84d1ae19ca.svg";
export { ForwardRef as ReactComponent };